import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { Deposito } from './depositos.model';

export const entityDepositosAdapter: EntityAdapter<Deposito> =
  createEntityAdapter<Deposito>({
    selectId: (model) => model.id,
    sortComparer: (a: Deposito, b: Deposito): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityDepositosState extends EntityState<Deposito> {
  isLoading?: boolean;
  hasAddedSuccess?: boolean;
  error?: Error | null;
}

export const initialState: EntityDepositosState =
  entityDepositosAdapter.getInitialState({
    isLoading: false,
    hasAddedSuccess: false,
    error: null
  });
